import { render, staticRenderFns } from "./LegalFileList.vue?vue&type=template&id=55a71cd1"
import script from "./LegalFileList.vue?vue&type=script&lang=js"
export * from "./LegalFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a71cd1')) {
      api.createRecord('55a71cd1', component.options)
    } else {
      api.reload('55a71cd1', component.options)
    }
    module.hot.accept("./LegalFileList.vue?vue&type=template&id=55a71cd1", function () {
      api.rerender('55a71cd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/settlementUnit/LegalFileList.vue"
export default component.exports